const protocol = location.protocol.replace(':', '')
const hostname = location.hostname
const path = location.hostname === 'localhost' ? '' : '/painel'
const branch = location.pathname.replace(/index\.html/, '').replace(/\/$/, '').replace(/^\/painel/, '')
const port = location.port ? `:${location.port}` : ''

export const MOUNTDOOM_URL = `${protocol}://${hostname}${port}${branch}`
export const MOUNTDOOM_2_URL = `${protocol}://${hostname}${port}${path}${branch}`


